/*
 * Ponte EComposer -> drawer carrello (assets/sg-upcart.js).
 * EComposer fa gia' l'aggiunta in Ajax (POST /cart/add con sections=cart-drawer,cart-icon-bubble)
 * ma sui bottoni con data-action="cart" poi porta a /cart. Qui:
 *  1) al click su un ATC EComposer con data-action="cart" cambiamo l'azione in "sg-drawer"
 *     (nessun redirect, ramo default di EComposer);
 *  2) EComposer.ajaxCartSuccess (il suo popup carrello) diventa un no-op quando esiste il drawer del tema;
 *  3) su "ec-cart-added" apriamo il drawer (window.sgUpcart);
 *     se manca, ripieghiamo sul drawer Dawn e poi su /cart.
 */
(function () {
  if (window.__sgEcomDrawer) return;
  window.__sgEcomDrawer = true;

  var pending = false;
  var pendingTimer = null;

  function getDrawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }

  function patchEcomposer() {
    var E = window.EComposer;
    if (!E || E.__sgPatched || typeof E.ajaxCartSuccess !== 'function') return;
    var orig = E.ajaxCartSuccess;
    E.ajaxCartSuccess = function () {
      if (window.sgUpcart || getDrawer()) return; // il drawer e' gestito da "ec-cart-added"
      return orig.apply(this, arguments);
    };
    E.__sgPatched = true;
  }

  function goCart() {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function openDrawer(res) {
    if (window.sgUpcart) {
      // stessa apertura ritardata dell'intercettore di /cart/add: un solo ridisegno
      if (typeof window.sgUpcart.added === 'function') window.sgUpcart.added(); else window.sgUpcart.refreshAndOpen();
      return;
    }
    var d = getDrawer();
    if (!d) return goCart();
    d.classList.remove('is-empty');
    var need = ['cart-drawer', 'cart-icon-bubble'];
    var ok = res && res.sections && need.every(function (k) { return res.sections[k]; });
    if (ok) {
      d.renderContents(res);
      return;
    }
    fetch('/?sections=' + need.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) { d.renderContents({ id: res && res.id, sections: sections }); })
      .catch(goCart);
  }

  // 1) il click arriva prima dei listener di EComposer (capture)
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-action="cart"], [data-sg-action="cart"]');
    if (!btn || !btn.closest('.ecom-product-form, form[action*="/cart/add"], .ecom-collection__product-item, .ecom-sticky__atc')) return;
    if (!getDrawer() && !window.sgUpcart) return;
    patchEcomposer();
    btn.setAttribute('data-sg-action', 'cart');
    btn.setAttribute('data-action', 'sg-drawer');
    pending = true;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { pending = false; }, 15000);
  }, true);

  // 3) aggiunta riuscita
  document.addEventListener('ec-cart-added', function (e) {
    if (!pending) return;
    pending = false;
    clearTimeout(pendingTimer);
    try { openDrawer(e.detail); } catch (err) { console.error('[sg-ecom-cart-drawer]', err); goCart(); }
  });

  // errore EComposer: non lasciare il flag acceso
  document.addEventListener('ec-cart-error', function () { pending = false; });

  patchEcomposer();
  window.addEventListener('load', patchEcomposer);
})();
